module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BagManagementCore', {
    key: _vm.bagId,
    attrs: {
      "bag-id": _vm.bagId
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-487659bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-487659bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/BagManagement/BagManagement.scp.html
// module id = 538
// module chunks = 0